import React from 'react'
import moment from 'moment'
import './Details.css'
import locationIcon from '../../Assets/custom-site/location.png'
import linkIcon from '../../Assets/custom-site/link.png'
import detailsImg from '../../Assets/custom-site/details.webp'

const Details = ({ colourScheme, weddingDate, weddingStartTime, weddingVenueName, weddingVenueAddress, weddingVenueTravelInfo, receptionVenueName, receptionVenueAddress, receptionStartTime, weddingReceptionTravelInfo, accommodationOptions = [], sharedVenue = false }) => {
    const venueDisplayName = (weddingVenueName || weddingVenueAddress?.venueName || weddingVenueAddress?.name || '').trim();
    // Use ceremony venue data for reception if sharedVenue is true
    const receptionDisplayName = sharedVenue 
        ? (weddingVenueName || weddingVenueAddress?.venueName || weddingVenueAddress?.name || '').trim()
        : (receptionVenueName || receptionVenueAddress?.venueName || receptionVenueAddress?.name || '').trim();
    const receptionAddress = sharedVenue ? weddingVenueAddress : receptionVenueAddress;
    const receptionTravelInfo = sharedVenue ? weddingVenueTravelInfo : weddingReceptionTravelInfo;
    const buildFullAddress = (addr) => {
        if (!addr) return '';

        // Support alternate key names just in case schema differs
        const line1 = addr.addressLine1 || addr.line1 || addr.street || '';
        const line2 = addr.addressLine2 || addr.line2 || '';
        const town = addr.town || addr.city || '';
        const county = addr.county || addr.state || '';
        const postcode = addr.postcode || addr.postalCode || addr.zip || '';

        return [line1, line2, town, county, postcode]
            .map(part => (typeof part === 'string' ? part.trim() : part))
            .filter(Boolean)
            .join(', ');
    }
    const subsections = [
        'When',
        'Where',
        'Travel',
        'Reception to follow',
        'When',
        'Where',
        'Travel',
        'Places to stay'
    ]

    return (
        <div 
            className={`details-container ${colourScheme}-details`}
            style={{
                '--details-bg-image': `url(${detailsImg})`
            }}
        >
            <div className="details-overlay"></div>
            <div className="details-inner">
                <h2 className="details-title">The Details</h2>
                <div className="details-left-image">
                    <img src={detailsImg} alt="Decorative details" />
                </div>
                <div className="details-content">
                    {subsections.map((title, idx) => {
                        const isReception = title.toLowerCase() === 'reception to follow'
                        return (
                            <div key={`${title}-${idx}`} className="details-subsection">
                                <h3 className={`details-subtitle ${isReception ? `${colourScheme}-highlight` : ''}`}>{title}</h3>
                                <div className="details-body">
                                    {title.toLowerCase() === 'when' && weddingDate && weddingStartTime && idx < 4 && (
                                        <p className="details-when-text">
                                            {moment(`${moment(weddingDate).format('YYYY-MM-DD')} ${weddingStartTime}`, 'YYYY-MM-DD HH:mm').format('dddd').toUpperCase()} {moment(weddingDate).format('Do MMMM YYYY')}, {moment(weddingStartTime, 'HH:mm').format('hh:mma').toUpperCase()}
                                        </p>
                                    )}
                                    {title.toLowerCase() === 'when' && receptionStartTime && idx >= 4 && (
                                        <p className="details-when-text">
                                            {moment(`${moment(weddingDate).format('YYYY-MM-DD')} ${receptionStartTime}`, 'YYYY-MM-DD HH:mm').format('dddd').toUpperCase()} {moment(weddingDate).format('Do MMMM YYYY')}, {moment(receptionStartTime, 'HH:mm').format('hh:mma').toUpperCase()}
                                        </p>
                                    )}
                                    {title.toLowerCase() === 'where' && idx < 4 && (
                                        <p className="details-text" style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                                            <img src={locationIcon} alt="Location" style={{ width: 18, height: 18, objectFit: 'contain' }} />
                                            <span>{[venueDisplayName, buildFullAddress(weddingVenueAddress)].filter(Boolean).join(', ')}</span>
                                        </p>
                                    )}
                                    {title.toLowerCase() === 'where' && idx >= 4 && (
                                        <p className="details-text" style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                                            <img src={locationIcon} alt="Location" style={{ width: 18, height: 18, objectFit: 'contain' }} />
                                            <span>{[receptionDisplayName, buildFullAddress(receptionAddress)].filter(Boolean).join(', ')}</span>
                                        </p>
                                    )}
                                    {title.toLowerCase() === 'travel' && idx === 2 && weddingVenueTravelInfo && (
                                        <p className="details-text">{weddingVenueTravelInfo}</p>
                                    )}
                                    {title.toLowerCase() === 'travel' && idx === 6 && receptionTravelInfo && (
                                        <p className="details-text">{receptionTravelInfo}</p>
                                    )}
                                    {title.toLowerCase() === 'places to stay' && idx === 7 && accommodationOptions.length > 0 && (
                                        <div>
                                            {accommodationOptions.map((accommodation, accIdx) => (
                                                <div key={accIdx} style={{ marginBottom: '20px' }}>
                                                    <p className="details-text" style={{ marginBottom: '4px' }}>
                                                        {accommodation.name}
                                                    </p>
                                                    {accommodation.url && (
                                                        <p className="details-text" style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                                                            <img src={linkIcon} alt="Link" style={{ width: 18, height: 18, objectFit: 'contain' }} />
                                                            <a 
                                                                href={accommodation.url} 
                                                                target="_blank" 
                                                                rel="noopener noreferrer"
                                                                className="details-text"
                                                                style={{ textDecoration: 'none' }}
                                                            >
                                                                {accommodation.url}
                                                            </a>
                                                        </p>
                                                    )}
                                                </div>
                                            ))}
                                        </div>
                                    )}
                                </div>
                            </div>
                        )
                    })}
                </div>
            </div>
        </div>
    )
}

export default Details
